import { Clipboard } from '@angular/cdk/clipboard';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-modal-executed-sql',
  templateUrl: './modal-executed-sql.component.html',
  styleUrls: ['./modal-executed-sql.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslocoPipe],
})
export class ModalExecutedSqlComponent {
  dialogRef = inject(MatDialogRef<ModalExecutedSqlComponent>);
  sql = inject<string>(MAT_DIALOG_DATA);
  private clipboard = inject(Clipboard);

  copied = false;

  copy(): void {
    this.clipboard.copy(this.sql);
    this.copied = true;
    setTimeout(() => (this.copied = false), 2000);
  }
}
